<template>
  <div class="score-box" @click="handleScoreClick">
    <div
      class="score"
      :class="{ actived: activatedScore >= score }"
      v-for="score in scores"
      :key="score"
      :data-score="score"
    >
      {{ score }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScoreBox',

  model: {
    prop: 'activatedScore',
    event: 'change'
  },

  props: {
    activatedScore: {
      type: [Number, String],
      default: -1
    }
  },
  data() {
    return {
      scores: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    }
  },
  methods: {
    handleScoreClick(e) {
      let score = e.target.dataset.score,
        activatedScore = this.activatedScore
      if (score && activatedScore != score) {
        this.$emit("change", score)
      }
    },
  }

}
</script>

<style lang="stylus" scoped>
.score-box {
  display: flex;
  justify-content: space-between;
  padding: 0 36px;
  box-sizing: border-box;

  .score {
    width: 59px;
    height: 200px;
    text-align: center;
    line-height: 200px;
    box-sizing: border-box;
    font-size: 40px;
    font-family: 'PingFang-SC-Medium';

    &:first-of-type {
      border-radius: 10px 0 0 10px;
    }

    &:last-of-type {
      border-radius: 0 10px 10px 0;
    }
  }
}

[data-theme='vip'] {
  .score {
    background: $inactived-color-vip;
    color: $dark-text-color;
  }

  .actived {
    background: $theme-color-vip;
    color: $bright-text-color;
  }
}

[data-theme='default'] {
  .score {
    background: $inactived-color;
    color: $dark-text-color;
  }

  .actived {
    background: $theme-color;
    color: $bright-text-color;
  }
}
</style>
